  /**
   * @param {string} prettyTime - Time in the format HH::MM:SS
   * @returns {number} - Seconds
   */
  export function getSecondsFromTimeString(time="00:00:00") {
      var ts = time.split(':'); // split it at the colons
      ts = ts.reverse();
      let seconds = 0;
      ts.forEach( (t,index) => {
        seconds += parseInt(t,10) * (60 ** index)
      })

      return seconds;
  }
  /**
   * @param {number} seconds
   */
  export function getTimeStringFromSeconds(_seconds = 0) {
    let hours   = Math.floor(_seconds / 3600);
    let minutes = Math.floor((_seconds - (hours * 3600)) / 60);
    let seconds = _seconds - (hours * 3600) - (minutes * 60);
    let h = `${hours}`;
    let m = `${minutes}`;
    let s = `${seconds}`;
    if (hours   < 10) {h = "0"+hours;}
    if (minutes < 10) {m = "0"+minutes;}
    if (seconds < 10) {s = "0"+seconds;}
    return `${h}:${m}:${s}`;
  }